module.exports = __webpack_public_path__ + "img/Bazooca.7cc728ee.webp";